<template>
  <div id="add">
    <!-- 头部 -->
    <div class="header">
      <h1>江苏省医疗机构预检分诊操作表</h1>
      <div class="tips">
        为了您和他人的健康和安全，请自觉凭有效身份证件原件实名制就诊，进入
        医院诊疗区域（含门诊、急诊和病房等区域）请自觉佩戴口罩，门诊行门诊手术、
        有创检查、胃肠镜等特殊治疗和住院期间请最多由一位家属陪同诊疗，遵守医院
        规章制度。
      </div>
      <div class="title">
        患者已充分理解目前新型冠状病毒肺炎防控形势严峻，自愿做出以下承诺：
      </div>
    </div>

    <!-- 患者信息 -->
    <div id="info">
      <van-cell-group>
        <van-field
          v-model="params.patientName"
          label="患者姓名"
          placeholder="请输入姓名"
        />
        <van-field
          v-model="params.temperature"
          label="患者体温"
          placeholder="请输入体温,34-42℃之间"
        />
        <van-field
          v-model="params.mobile"
          label="联系电话"
          placeholder="请输入联系电话"
        />
        <van-field
          v-model="params.idcard"
          label="身份证号"
          placeholder="请输入身份证号码"
        />
      </van-cell-group>
    </div>

    <!-- 表单 -->
    <div class="form">
      <div class="item">
        <div class="title">
          1.本人（及陪同家属）是否境外及中高风险地区旅居史(28 天内)；
        </div>
        <van-radio-group v-model="params.abroadSojournHistory">
          <van-radio name="是" class="checkBox">是</van-radio>
          <van-radio name="否" class="checkBox">否</van-radio>
        </van-radio-group>
      </div>

      <div class="item">
        <div class="title">
          2.本人（及陪同家属）是否与境外及中高风险地区人员、物品接触史（21 天
          内）；
        </div>
        <van-radio-group v-model="params.abroadContactHistory">
          <van-radio name="是" class="checkBox">是</van-radio>
          <van-radio name="否" class="checkBox">否</van-radio>
        </van-radio-group>
      </div>

      <div class="item">
        <div class="title">
          3.本人（及陪同家属）是否国内新冠疫情中高风险地区旅行史人员接触史（21
          天内）
        </div>
        <van-radio-group v-model="params.domesticContactHistory">
          <van-radio name="是" class="checkBox">是</van-radio>
          <van-radio name="否" class="checkBox">否</van-radio>
        </van-radio-group>
      </div>

      <div class="item">
        <div class="title">
          4.本人（及陪同家属）是否聚集性发病史（2 例及以上发热或呼吸道症状病
          例）（14 天内）；
        </div>
        <van-radio-group v-model="params.domesticDiseaseHistory">
          <van-radio name="是" class="checkBox">是</van-radio>
          <van-radio name="否" class="checkBox">否</van-radio>
        </van-radio-group>
      </div>

      <div class="item">
        <div class="title">
          5.本人（及陪同家属）是否发热、干咳、鼻塞、流涕、咽痛、腹泻、乏力、
          肌痛、结膜炎、嗅觉减退等症状。
        </div>
        <van-radio-group v-model="params.ynSymptoms">
          <van-radio name="是" class="checkBox">是</van-radio>
          <van-radio name="否" class="checkBox">否</van-radio>
        </van-radio-group>
      </div>

      <div class="item">
        <div class="title">
          6.是否高风险岗位人员
          <span class="classify">
            (包含：
            医疗机构内的发热门诊、隔离病房、新冠核酸检验等存在高风险暴露的医务人员;
            从事呼吸道标本采集和检测的工作人员; 国际交通运输工具从业人员;
            船舶引航员等登临外籍船舶作业人员;
            移民、海关以及市场监管系统一线工作人员;
            进口冷链食品含外包装监管和从业人员; 口岸进口货物直接接触人员;
            集中隔离医学观察场所工作人员; 接驳转运工作和“快捷通道”工作人员;
            其他经风险研判确定的高风险岗位人员 )。
          </span>
        </div>
        <van-radio-group v-model="params.naNegativeReport">
          <van-radio name="是" class="checkBox">是</van-radio>
          <van-radio name="否" class="checkBox">否</van-radio>
        </van-radio-group>
      </div>

      <div class="item">
        <div class="title">7.核酸检测</div>
        <van-radio-group v-model="params.hsjcStatus" @change="gropChangehs">
          <van-radio name="是" class="checkBox">是</van-radio>
          <van-radio name="否" class="checkBox">否</van-radio>
        </van-radio-group>
        <van-cell-group v-if="params.hsjcStatus == '是'">
          <!-- <van-cell title="频次" :value="params.naFrequency" is-link @click="hsShow = true" /> -->
          <van-cell>
            <template #title>
              <span class="custom-title">频次(天)</span>
            </template>
            <template #right-icon>
              <van-stepper v-model="params.naFrequency" min="0" />
            </template>
          </van-cell>

          <van-cell
            title="最近一次检测时间"
            :value="params.lastDetectionTime"
            is-link
            @click="
              hsDateShow = true;
              dateFlag = 1;
            "
          />
        </van-cell-group>
      </div>

      <div class="item">
        <div class="title">8.新冠疫苗接种情况</div>
        <van-radio-group v-model="params.jzStatus" @change="gropChangejz">
          <van-radio name="是" class="checkBox">是</van-radio>
          <van-radio name="否" class="checkBox">否</van-radio>
        </van-radio-group>
        <van-cell-group v-if="params.jzStatus == '是'">
          <!-- <van-cell title="接种针数" value="内容" is-link /> -->
          <van-cell>
            <template #title>
              <span class="custom-title">接种针数</span>
            </template>
            <template #right-icon>
              <van-stepper v-model="params.vaccinated" min="0" :max="3" />
            </template>
          </van-cell>
          <!-- <van-cell title="共计几针" value="内容" is-link /> -->

          <van-cell>
            <template #title>
              <span class="custom-title">共计几针</span>
            </template>
            <template #right-icon>
              <van-stepper v-model="params.totalNeedles" min="0" max="3" />
            </template>
          </van-cell>

          <van-cell
            title="最后一针接种日期"
            :value="params.lastVaccinationDate"
            is-link
            @click="
              hsDateShow = true;
              dateFlag = 2;
            "
          />
        </van-cell-group>
      </div>
    </div>

    <!-- footer -->
    <div id="footer">
      <div class="tips">
        <span>特别提醒：</span
        >根据《传染病防治法》《治安管理处罚法》等法律规定，如果本
        人（及陪同家属）隐瞒上述情况或者拒绝配合医务人员开展调查等处置措施的，
        将承担相应法律责任。
      </div>
    </div>
    <div class="fixed">
      <van-checkbox v-model="accepted" class="accepted"
        >承诺以上情况均属实</van-checkbox
      >
      <van-button
        type="primary"
        size="large"
        class="btn"
        :disabled="!accepted"
        @click="submit"
        >提交</van-button
      >
    </div>
    <!-- 弹出层 -->
    <!-- 核酸检测频次 -->
    <!-- <van-popup position="bottom" v-model="hsShow">
      <van-picker
        title="核酸检测频次"
        show-toolbar
        :columns="hsColumns"
        @confirm="hsOnConfirm"
        @cancel="hsOncancel"
      />
    </van-popup> -->

    <!-- 核酸检测最近一次接种日期 -->
    <van-popup position="bottom" v-model="hsDateShow">
      <van-datetime-picker
        v-model="hsCurrentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
        @confirm="hsDateOnConfirm"
        @cancel="hsDateOncancel"
      />
    </van-popup>
  </div>
</template>

<script>
import { commonAjax } from "../common/js/api.js";
import { validateIdCard, validatePhone } from "../common/js/utils";
import moment from "moment";
export default {
  components: {},
  props: {},
  data() {
    return {
      radio: "",
      checked: false,
      //核酸检测选择列表
      // hsShow: false,
      hsColumns: ["7天", "15天", "30天", "60天", "90天", "无"],

      //核酸检测日期选择列表
      hsDateShow: false,
      minDate: new Date(2019, 0, 1),
      maxDate: new Date(2025, 10, 1),
      hsCurrentDate: new Date(),

      //接种针数
      value: 0,

      dateFlag: 1, //dateFlag为1：核酸检测最近一次检测时间；2：新冠疫苗最后一针接诊日期

      // 承诺以上情况属实
      accepted: false,

      params: {
        openid: "",
        abroadSojournHistory: "",
        abroadContactHistory: "",
        domesticContactHistory: "",
        domesticDiseaseHistory: "",
        ynSymptoms: "",
        naFrequency: "",
        lastDetectionTime: "",
        vaccinated: "",
        totalNeedles: "",
        lastVaccinationDate: "",
        inputDate: "",
        temperature: "",

        mobile: "",
        idcard: "",
        patientName: "",
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    search() {
      commonAjax(
        { startTime: this.startTime, endTime: this.endTime },
        "/wechat-web/api/info/getInfoList"
      ).then((res) => {});
    },

    // 核酸检测确认按钮
    // hsOnConfirm(value) {
    //   this.hsShow = false;
    //   this.params.naFrequency = value
    // },
    // 核酸检测取消按钮
    // hsOncancel() {
    //   this.hsShow = false;
    // },

    // 核酸日期选择确认按钮
    hsDateOnConfirm(value) {
      this.hsDateShow = false;
      console.log(this.dateFlag == 1 ? "核酸检测" : "新冠疫苗");
      console.log(value);
      value = moment(value).format("YYYY-MM-DD");
      if (this.dateFlag == 1) {
        this.params.lastDetectionTime = value;
        return;
      }
      if (this.dateFlag == 2) {
        this.params.lastVaccinationDate = value;
        return;
      }
    },
    // 核酸检测取消按钮
    hsDateOncancel() {
      this.hsDateShow = false;
    },

    // 提交按钮
    submit() {
      console.log(this.params)
      if(!this.params.openid){
        return this.$toast('未获取到openid')
      }
      if(!this.params.patientName){
        return this.$toast('请输入患者姓名')
      }
      if(!this.params.temperature){
        return this.$toast('请输入患者体温')
      }else if(this.params.temperature<34||this.params.temperature>42){//
        return this.$toast('患者体温应在34℃-42℃之间')
      }
      if(this.params.mobile.length==11){
        if(!validatePhone(this.params.mobile)){

          this.$toast('请输入正确的联系电话')
        }
      }else{
        return this.$toast('请输入联系电话或格式错误')
      }
      if(!validateIdCard(this.params.idcard)){
        return this.$toast('请输入身份证号码或格式错误！')
      }
      if(!this.params.abroadSojournHistory){
        return this.$toast('请选择是否为境外及中高风险地区旅居史')
      }
      if(!this.params.abroadContactHistory){
        return this.$toast('请选择是否与境外及中高风险地区人员、物品接触史')
      }
      if(!this.params.domesticContactHistory){
        return this.$toast('请选择是否国内新冠疫情中高风险地区旅行史人员接触史')
      }
      if(!this.params.domesticDiseaseHistory){
        return this.$toast('请选择是否聚集性发病史')
      }
      if(!this.params.ynSymptoms){
        return this.$toast('请选择是否发热')
      }
      if(!this.params.naNegativeReport){
        return this.$toast('请选择是否高风险岗位人员')
      }

      if (!this.params.hsjcStatus) {
        return this.$toast("请选择核酸检测");
      }

      if (this.params.hsjcStatus == "是") {
        if (!this.params.naFrequency) {
          return this.$toast("请选择核酸检测频次");
        }

        if (!this.params.lastDetectionTime) {
          return this.$toast("请选择最近一次检测时间");
        }
      }

      if (!this.params.jzStatus) {
        return this.$toast("请选择新冠疫苗接种情况");
      }

      if (this.params.jzStatus == "是") {

        if (!this.params.vaccinated) {
          return this.$toast("请输入接种针数");
        }

        if (!this.params.totalNeedles) {
          return this.$toast("请选择共计几针");
        }
        if (!this.params.lastVaccinationDate) {
          return this.$toast("请选择最后一针接种日期");
        }
      }

      this.params.inputDate = moment(new Date()).format("YYYY-MM-DD");
      let formdata = new FormData();
      for (let key in this.params) {
        formdata.append(key, this.params[key]);
      }
      commonAjax(formdata, "/dq/api/authex/savePreviewtriage").then((res) => {
        if (res.code == 1) {
          this.$toast(res.message || "保存成功");
          setTimeout(() => {
            this.$router.push(`/addSuccess`);
          }, 2000);
        }
      });
    },
    //检测当日是否已经填写
    getDetail() {
      let formData = new FormData();
      formData.append("openid", this.params.openid);
      commonAjax(formData, "/dq/api/authex/selectChecking").then((res) => {
        console.log(res);
        if (res.code == 1 && res.data.idcard) {
          this.$toast("你已登记,跳转到详情页面");
          setTimeout(() => {
            this.$router.push("/addSuccess");
          }, 2000);
        }
      });
    },
    //多选框变化触发
    checkBoxChange(val) {},

    //核酸检测“是”、“否”切换
    gropChangehs(val){
      if(val=='否'){//如果选择否，把最近一次检测日期、频次清除
        this.params.naFrequency = 0;
        this.params.lastDetectionTime = ''

      }
    },

    //疫苗接种“是”、“否”
    gropChangejz(val){
      if(val=='否'){
        this.params.vaccinated = 0;
        this.params.totalNeedles = 0;
        this.params.lastVaccinationDate = ''
      }

    }

  },
  created() {},
  mounted() {
    let openid = localStorage.getItem("openid");
    if (openid) {
      this.params.openid = openid;
      this.getDetail();
    } else {
      this.$toast("未获取到openid");
      return;
    }
  },
};
</script>
<style scoped lang="less">
#add {
  font-size: 16px;
  margin-bottom: 220px;
  padding: 10px;

  // 头部
  .header {
    background: #ffffff;
    padding: 10px;
    border-radius: 10px;
    color: #000000;
    margin-bottom: 20px;
    h1 {
      font-size: 20px;
      margin-bottom: 20px;
    }
    .tips {
      text-align: left;
      line-height: 50px;
      text-indent: 50px;
    }
    .title {
      color: red;
      text-align: left;
      font-weight: bold;
    }
  }

  // 患者信息
  #info {
    margin-bottom: 20px;
    border-radius: 8px;

    /deep/ .van-field__label {
      color: #000000;
      font-size: 16px;
    }
  }

  // 表单
  .form {
    width: 100%;
    height: 100%;
    margin-top: 20px;

    .item {
      background: #ffffff;
      text-align: left;
      margin-bottom: 20px;
      border-radius: 8px;
      padding: 20px;

      .title {
        margin-bottom: 20px;
        line-height: 40px;

        .classify {
          color: #999999;
          font-size: 12px;
        }
      }
      /deep/ .checkBox {
        padding: 10px;
      }
    }
  }

  // footer
  #footer {
    background: #ffffff;

    .tips {
      span {
        font-weight: bold;
      }
      padding: 20px 10px;
      text-align: left;
    }
  }

  .fixed {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    background: #ffffff;
    border-top: 1px solid #cccccc;
    // f0f0f0f0
    padding: 10px;
    box-sizing: border-box;

    .accepted {
      padding: 20px;
    }
  }
}
</style>
